<div class="container">
  <div class="row">
    <div class="col s12 m4">
      <div class="card">
        <div class="card-image">
          <img class="activator" loading="lazy" src="https://ik.imagekit.io/infans/assets/Ella?tr=h-370"
            alt="vroedvrouw Ella">
        </div>
        <div class="card-content">
          <span class="card-title activator grey-text text-darken-4">
            Manuella Mertens
            <svg class="icon right">
              <use xlink:href="assets/sprites.svg#ellipsis-v"></use>
            </svg>
          </span>
          <p class="black-text function-title">Zelfstandige vroedvrouw</p>
          <p class="black-text">Praktijk Peer</p>
          <p>Vroedvrouw met <a mTooltip data-position="bottom"
              data-tooltip="* bepaalde medicatie mag een vroedvrouw voorschrijven en hoef je niet voor langs te gaan bij uw arts."
              href="https://www.riziv.fgov.be/nl/professionals/individuelezorgverleners/vroedvrouwen/Paginas/vroedvrouw-geneesmiddelen-voorschrijven-.aspx"
              target="_blank" rel="noopener">voorschrijfrecht</a></p>
          <p>Draagconsulent</p>
          <p mTooltip data-position="bottom"
            data-tooltip="* lactatiekunde is de kennis van de menselijke borstvoeding en de processen die daarmee gemoeid zijn zoals melkproductie en melkafgifte, de samenstelling van de moedermelk en het drinken aan de borst. De lactatiekundige richt zich op de begeleiding van moeder en kind tijdens de lactatie.">
            <a href="https://www.bvl-borstvoeding.be/nl/(aanstaande)_ouders/meer_weten_over_de_begeleiding_door_een_lactatiekundige_(ibclc)/bekwaamheid_van_de_lactatiekundige_(ibclc)/231"
              target="_blank" rel="noopener">IBCLC Lactatiekundige</a>
          </p>
        </div>
        <div class="card-reveal">
          <span class="card-title grey-text text-darken-4">
            Manuella Mertens
            <svg class="icon right">
              <use xlink:href="assets/sprites.svg#times"></use>
            </svg>
          </span>
          <p>Hoi! Mijn naam is Manuella, je mag het gerust afkorten naar Ella ;)</p>
          <p>In 1989 ben ik op de internationale dag van de verpleging geboren in Mechelen. Na in Mechelen te zijn
            opgegroeid, heb ik in Leuven gewoond, gestudeerd en gewerkt. Mijn jaren in Leuven mag je gerust dynamisch
            noemen. Zo werd ik er trotse bezitter van de bachelor vroedkunde en de master management en beleid in de
            gezondheidszorg. Tijdens mijn bachelor vroedkunde heb ik een stage in Ecuador gedaan. Hiervoor ben ik de
            zomer voordien een intensieve cursus Spaans in Guatemala gaan volgen. Er is geen ontkennen aan, vroedkunde
            en reizen zijn mijn grootste passies! Ook op het gebied van werkervaring in de verpleeg- en vroedkunde is
            Leuven een grote pijler geweest. En laatst genoemd maar zeker niet minder waardevol, is het ook de stad waar
            ik de man heb ontmoet waar ik mijn hart aan verloren ben.
          </p>
          <p>In 2015 hebben we de stap gezet om een huisje te kopen in het knusse stadje Peer, waar in 2018 tevens onze
            eerste prachtige zoon is geboren. In 2021 kregen we een tweede fantastische zoon. Beide hebben zo'n 1,5 jaar
            borstvoeding gekregen, het is gestopt toen zij aangaven dat ze er genoeg van hadden. Bijscholen vind ik
            enorm belangrijk, de lijst van bijscholingen die ik reeds gevolgd heb is behoorlijk en er is altijd wel iets
            waarin ik mij aan het bijscholen ben. Zo heb ik onder andere naast mijn cursus lactatiekunde ook een
            onafhankelijke en verdiepte cursus over flesvoeding gevolgd. Mijn oudste zoon was een zogenaamd
            "huilbaby'tje", voor hem heb ik onder meer koemelk, soja en ei vrij dieet gevolgd, ik heb me toen enorm in
            koemelkallergie verdiept en ook de masterclass hierin gevolgd. Ook starten met vaste voeding volgens de
            Rapley methode beheers ik en heb ik toegepast bij mijn eigen kindjes. Ik heb ook nog een postgraduaat
            preconceptie- en fertiliteitszorg met succes afgerond.
          </p>
          <p>Na jaren ervaring in loondienst heb ik de stap gezet naar zelfstandige vroedvrouw in 2016. In 2019 heb ik
            het geluk gehad om een team te kunnen vormen met Mieke, samen hebben we de praktijk Infans opgestart. In
            2025 is hier Thessa bijgekomen en zo groeit Infans in alle glorie. Infans is de beste wending in mijn
            carrière. Vroedvrouw zijn, ik doe het met hart en ziel.
          </p>
        </div>
      </div>
    </div>

    <div class="col s12 m4">
      <div class="card">
        <div class="card-image">
          <img loading="lazy" class="activator" src="https://ik.imagekit.io/infans/assets/mieke_grass?tr=h-370"
            alt="vroedvrouw Mieke">
        </div>
        <div class="card-content">
          <span class="card-title activator grey-text text-darken-4">
            Mieke Smeers
            <svg class="icon right">
              <use xlink:href="assets/sprites.svg#ellipsis-v"></use>
            </svg>
          </span>
          <p class="black-text function-title">Zelfstandige vroedvrouw</p>
          <p class="black-text">Praktijk Peer</p>
          <p>Vroedvrouw met <a mTooltip data-position="bottom"
              data-tooltip="* bepaalde medicatie mag een vroedvrouw voorschrijven en hoef je niet voor langs te gaan bij uw arts."
              href="https://www.riziv.fgov.be/nl/professionals/individuelezorgverleners/vroedvrouwen/Paginas/vroedvrouw-geneesmiddelen-voorschrijven-.aspx"
              target="_blank" rel="noopener">voorschrijfrecht</a></p>
          <p>Draagconsulent</p>
          <p mTooltip data-position="bottom"
            data-tooltip="* lactatiekunde is de kennis van de menselijke borstvoeding en de processen die daarmee gemoeid zijn zoals melkproductie en melkafgifte, de samenstelling van de moedermelk en het drinken aan de borst. De lactatiekundige richt zich op de begeleiding van moeder en kind tijdens de lactatie.">
            <a href="https://www.bvl-borstvoeding.be/nl/(aanstaande)_ouders/meer_weten_over_de_begeleiding_door_een_lactatiekundige_(ibclc)/bekwaamheid_van_de_lactatiekundige_(ibclc)/231"
              target="_blank" rel="noopener">IBCLC Lactatiekundige</a>
          </p>
        </div>
        <div class="card-reveal">
          <span class="card-title grey-text text-darken-4">
            Mieke Smeers
            <svg class="icon right">
              <use xlink:href="assets/sprites.svg#times"></use>
            </svg>
          </span>
          <p>Even voorstellen… Ik ben Mieke Smeers</p>
          <p>Ik ben getrouwd en trotse mama van twee opgroeiende kinderen. Dankzij hen weet ik uit eigen ervaring dat
            het ouderschap niet alleen prachtig en intens is, maar soms ook best onzeker kan voelen. Precies daarom heb
            ik er mijn missie van gemaakt om andere gezinnen te ondersteunen in die bijzondere periode.
          </p>
          <p>Als vroedvrouw en lactatiekundige IBCLC begeleid ik ouders met veel liefde vanaf de kinderwens tot lang na
            de geboorte. Ik bied een luisterend oor, praktische hulp en advies zodat jullie met vertrouwen jullie eigen
            weg kunnen gaan als ouder.
          </p>
          <p>Naast de algemene begeleiding heb ik me ook verdiept in borstvoedingsproblemen, waaronder de opvolging bij
            een frenectomie(tong- of lipriempje). Samen zorgen we ervoor dat borstvoeding zo comfortabel en vlot
            mogelijk kan verlopen.
          </p>
          <p>Ik geloof dat elk gezin recht heeft op warme, deskundige en persoonlijke zorg. Zorg die vertrouwen geeft en
            ruimte schept om te groeien.
          </p>
          <p>
            Ik kijk ernaar uit om jullie te ontmoeten en samen dit unieke avontuur te beleven. 💛
          </p>
        </div>
      </div>
    </div>

    <div class="col s12 m4">
      <div class="card">
        <div class="card-image">
          <img class="activator" loading="lazy" src="https://ik.imagekit.io/infans/assets/thessa_tree?tr=h-370"
            alt="vroedvrouw Thessa">
        </div>
        <div class="card-content">
          <span class="card-title activator grey-text text-darken-4">
            Thessa Hoomans
            <svg class="icon right">
              <use xlink:href="assets/sprites.svg#ellipsis-v"></use>
            </svg>
          </span>
          <p class="black-text function-title">Zelfstandige vroedvrouw en kinesist</p>
          <p class="black-text">Praktijk Tessenderlo</p>
          <p>Vroedvrouw met <a mTooltip data-position="bottom"
              data-tooltip="* bepaalde medicatie mag een vroedvrouw voorschrijven en hoef je niet voor langs te gaan bij uw arts."
              href="https://www.riziv.fgov.be/nl/professionals/individuelezorgverleners/vroedvrouwen/Paginas/vroedvrouw-geneesmiddelen-voorschrijven-.aspx"
              target="_blank" rel="noopener">voorschrijfrecht</a></p>
          <p>Draagconsulent</p>
          <p>&nbsp;</p>
        </div>
        <div class="card-reveal">
          <span class="card-title grey-text text-darken-4">
            Thessa Hoomans
            <svg class="icon right">
              <use xlink:href="assets/sprites.svg#times"></use>
            </svg>
          </span>
          <p>Hoi! Ik ben Thessa, mama van drie lieve dochters en een zoon, en ik ben getrouwd met Bert.
            Oorspronkelijk kom ik uit Noord-Limburg, maar mijn hart volgde de liefde naar het groene,
            bosrijke Tessenderlo. In 2008 heb ik mijn Master in de kinesitherapie behaald, met een
            passie voor pediatrische kinesitherapie en psychomotoriek. Na mijn studies werkte ik in
            verschillende praktijken en rusthuizen, altijd met een grote glimlach op mijn gezicht.
            Tegenwoordig werk ik nog steeds in een groepspraktijk, maar ik heb ook mijn eigen praktijk
            opgericht – helemaal gericht op vrouwen en kinderen. Want wat is er mooier dan een vrouw
            in haar kracht zien/zetten en een kind zien ontwikkelen? Het ouderschap heeft ook mijn
            wereld compleet veranderd. Toen ik in 2013 voor het eerst mama werd van mijn
            tweelingdochters, gevolgd door mijn zoon in 2015 en mijn jongste dochter in 2018, heb ik zelf
            mogen ervaren wat vroedvrouwen betekenen. Het was een eye-opener! In 2020 belandde ik
            door een burn-out in een moeilijke periode. Samen met mijn loopbaancoach heb ik gezocht
            naar wat ik écht wil doen voor de rest van mijn leven. En ja, de liefde voor vroedkunde kwam
            toen weer helemaal naar boven! In 2021 begon ik aan de opleiding tot Bachelor in de
            Vroedkunde, die ik in 2025 met onderscheiding heb afgerond. Het combineren van studeren,
            werken en gezin was een flinke uitdaging, maar ik heb er geen seconde spijt van. Tijdens
            mijn stages in ziekenhuizen en bij inspirerende vroedvrouwen zoals Ella en Mieke heb ik mijn
            passie verder ontdekt. Het werd voor mij duidelijk: dit is de weg die ik wil bewandelen. Want
            er is niets mooier dan gezinnen te begeleiden op dat magische moment van kinderwens,
            zwangerschap, geboorte en alles daarna.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col s12">
      <p>Anno 2019 is Infans geboren in Peer en Houthalen. We werden al gauw van ver uit onze regio gevraagd voor onze
        gespecialiseerde begeleiding. Het is dan ook een enorme meerwaarde dat in 2025 ons team is uitgebreid in regio
        Tessenderlo.
        Wij werken graag als team samen naar een persoonlijke begeleiding op maat van jullie behoeften. Dit vanaf de
        kinderwens tot (meer dan) een jaar na de geboorte. Een goede vertrouwensband is in deze bijzondere periode van
        jullie leven zeer belangrijk. Daarom zien we jullie graag zo vroeg mogelijk om deze band te kunnen opbouwen.
      </p>
      <p>
        Door als team samen te werken, staan wij garant voor een continue bereikbaarheid. Daarnaast staan we bekend voor
        onze toch wel brede maar
        ook zeer actueel wetenschappelijk gebaseerde kennis, dit is ook wat we zelf heel erg belangrijk vinden. We
        scholen ons dan ook continu bij en
        stemmen dit op elkaar af om een gelijkgestemde begeleiding te waarborgen.</p>
      <p>Wij zijn alvast benieuwd naar wie jullie zijn, we beginnen graag vroeg met een kennismakingsgesprek waarin we
        <a [routerLink]="['/afspraak']" [state]="{ care: 'FIRST_CONSULT_PRENATAL' }" href="/afspraak">kennismaken</a>,
        uitgebreid vertellen wat je van ons kan verwachten en jullie vanaf het prille begin optimaal kunnen begeleiden
        in de meest bijzondere gebeurtenis van jullie leven. Een afspraak boeken kan steeds via onze online
        afsprakenkalender <a [routerLink]="['/']" fragment="afspraak" href="#afspraak">hier</a>.
        Nog vragen? Contacteer ons vrijblijvend op <a href="tel:+32460230233">0460 230 233</a> of stuur ons een e-mail
        op <a href="mailto:info@infans.be">info&#64;infans.be</a>
      </p>
    </div>
  </div>

  <figure class="center-align">
    <img mMaterialbox width="150" height="150" ngSrc="assets/goodpracticelogo.webp" data-caption="Kwaliteitsvolle zorg"
      alt="good practice logo">
    <figcaption><a href="https://www.vroedvrouwen.be/good-practice-logo">Kwaliteitsvolle zorg</a></figcaption>
  </figure>

</div>